@if (urlToUse | async; as data) {
  <img (load)="onLoad($event)" (error)="onError($event)" [src]="data.safeUrl" [class.clickable]="expandable" [class.contain]="contain" [class.pikkukuva]="pikkukuva" [class.pikkukuva-ladattu]="pikkukuva && !ladataan" alt="" (click)="setExpandedState()" />
  @if (isExpanded) {
    <img class="clickable expanded" (load)="onLoad($event)" (error)="onError($event)" [src]="data.safeUrl" (click)="setExpandedState()" />
  }
}
@if (pikkukuva) {
  @if (eiKuvaa) {
    <div class="pikkukuva-ei-kuvaa">{{ 'tositteet.ei-kuvaa' | translate | async }}</div>
  } @else if (ladataan) {
    <div class="pikkukuva-siluetti" aria-hidden="true">
      <span class="pikkukuva-siluetti-rivi pikkukuva-siluetti-otsikko"></span>
      <span class="pikkukuva-siluetti-rivi"></span>
      <span class="pikkukuva-siluetti-rivi pikkukuva-siluetti-lyhyt"></span>
      <span class="pikkukuva-siluetti-rivi"></span>
      <span class="pikkukuva-siluetti-rivi pikkukuva-siluetti-lyhyt"></span>
      <span class="pikkukuva-siluetti-rivi pikkukuva-siluetti-summa"></span>
    </div>
  }
} @else {
  <div lemon-loading [show]="ladataan" [class.thumbnail-lataus]="thumbnail"></div>
}
